<template>
  <v-flex xs12 sm6 d-flex>
    <v-select
      :items="ordinations"
      label="Ordenação"
      v-model="ordination"
      item-text="title"
      item-value="business"
      return-object
      prepend-icon="swap_vert"
    ></v-select>
  </v-flex>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as business from '@/helpers/business';

export default {
  name: 'Ordination',
  computed: {
    ordination: {
      get() {
        return this.model;
      },
      set(newOrdination) {
        this.updateOrdination(newOrdination.business);
        this.model;
      },
    },
    ...mapGetters({
      model: 'deposits/ordination',
    }),
  },
  methods: {
    ...mapActions({
      updateOrdination: 'deposits/updateOrdination',
    }),
  },
  data: () => ({
    ordinations: [
      { title: 'Mais recentes', business: business.DEPOSIT_MOST_RECENT_ORDER },
      { title: 'Mais antigos', business: business.DEPOSIT_LOWER_ORDER },
      { title: 'Valor mais alto', business: business.DEPOSIT_HIGHEST_VALUE_ORDER },
      { title: 'Valor mais baixo', business: business.DEPOSIT_LOWER_VALUE_ORDER },
    ],
  }),
};
</script>